module.exports = __webpack_public_path__ + "static/media/dws_auth.b12f2bc2.png";